import * as React from 'react';
import gql from 'graphql-tag';
import AuthorizedMutation from './AuthorizedMutation';

const GQL = gql`
  mutation registerUser($params: RegisterUserInput!) {
    registerUser(params: $params) {
      id
      firstName
      lastName
      email
    }
  }
`;

export type RegisterUserFn = (params: UserParams) => void;

interface UserParams {
  firstName: string;
  lastName: string;
}

interface Props {
  onCompleted: (data: User | undefined) => void;
  children: (
    execute: RegisterUserFn,
    loading: boolean
  ) => React.ReactNode;
}

const handleCompleted = (props: Props, data: any) => {
  console.warn(data);
  props.onCompleted(data.registerUser as User);
};

const RegisterUserProvider: React.StatelessComponent<Props> = (props: Props) => {
  return (
    <AuthorizedMutation
      mutation={GQL}
      onCompleted={data => handleCompleted(props, data)}
    >
      {(mutateFn, result) =>
        props.children(
          params => mutateFn({ variables: { params } }),
          result.loading
        )
      }
    </AuthorizedMutation>
  );
};

export default RegisterUserProvider;



// WEBPACK FOOTER //
// ./src/providers/RegisterUserProvider.tsx